var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowOnInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EB863C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18C31.5 17.1716 30.8284 16.5 30 16.5C29.1716 16.5 28.5 17.1716 28.5 18L31.5 18ZM28.5 18L28.5 42H31.5L31.5 18L28.5 18Z",
    fill: "#EB863C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33L30 42L21 33",
    stroke: "#EB863C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowOnInventory);
export default __webpack_public_path__ + "static/media/Low_on_Inventory.6519f8fdf044aac8b4c00a7085e9d3ad.svg";
export { ForwardRef as ReactComponent };